import upperFirst from "lodash/upperFirst";

import { declOfNum } from "utils/decl-of-num/decl-of-num";

/** Строит ошибку "Паспорт введён неверно. Осталось N попыток" используя склонения */
export const buildErrorMessage = (count: number) => {
  const rest = count % 10 === 1 ? "осталась" : "осталось";
  return `Паспорт введён неверно. ${upperFirst(rest)} ${count} ${declOfNum(
    count,
    "попыт|ка|ки|ок"
  )}`;
};
